<template>
  <div style="margin: 80px">
    <el-carousel :interval="4000" type="card" height="400px">
      <el-carousel-item v-for="(item, index) in images" :key="index">
        <!-- 使用 img 标签显示图片 -->
        <el-image :src="item" alt="carousel-image"
                  style="width: auto; height: 100%; object-fit: cover;object-position: center;"></el-image>
      </el-carousel-item>
    </el-carousel>
  </div>
  <div class="intro-section" style="margin: 50px 100px">
    <h2 style="font-size: 30px; color: #617173;">
      簡介
    </h2>
    <h2 style="font-size: 20px; color: #617173;">
      華夏青年中醫協會成立於2023年，是一個非牟利專業組織，致力於凝聚青年中醫師及中醫學生的力量，推動中醫藥的傳承與創新。
    </h2>
    <p style="font-size: 15px; color: #617173;">
      針對中醫領域面臨的專業人才斷層與青年發展需求，本會以「青年培育青年，專業鏈接未來」為核心理念，
    </p>
    <p style="font-size: 15px; color: #617173;">
      搭建專屬青年中醫群體的成長支持平臺，促進學術精進、職涯發展與跨代交流。
    </p>
  </div>
  <el-divider style="width: 1200px;margin-left: 100px" />
  <div style="margin: 50px 100px" >
    <h2 style="font-size: 30px; color: #617173;">
      最新消息
    </h2>
    <el-link :underline="false" target="_blank" @click="$router.push('/activity1')"
             style="font-size: 20px; color: #617173;margin: 20px 20px; display: block;">
      本科生學分講座
    </el-link>
    <el-link :underline="false" target="_blank" style="font-size: 20px; color: #617173;margin: 20px 20px; display: block;">
      消息2
    </el-link>
    <el-link :underline="false" target="_blank" style="font-size: 20px; color: #617173;margin: 20px 20px; display: block;">
      消息3
    </el-link>
  </div>
  <el-divider style="width: 1200px;margin-left: 100px" />
  <div style="margin: 50px 100px" >
    <h2 style="font-size: 30px; color: #617173;">
      過往活動
    </h2>
    <el-link :underline="false" target="_blank" @click="$router.push('/activity1')"
             style="font-size: 20px; color: #617173;margin: 20px 20px; display: block;">
      香港大學中醫講座
    </el-link>
    <el-link :underline="false" target="_blank" style="font-size: 20px; color: #617173;margin: 20px 20px; display: block;">
      活動2
    </el-link>
    <el-link :underline="false" target="_blank" style="font-size: 20px; color: #617173;margin: 20px 20px; display: block;">
      活動3
    </el-link>
  </div>
  <el-divider style="width: 1350px;margin-left: 30px" />
  <el-footer>
    <div>
      <div style="color: #617173; text-align:center; font-size: 10px;margin-bottom: 10px">
        華夏青年中醫協會
      </div>
      <div style="margin-left: 610px; margin-bottom: 20px">
        <img src="../assets/logo1.png" alt="Logo" style="width: 170px; height: auto">
      </div>
    </div>
  </el-footer>
</template>

<script>
export default {
  name: "MainPage",
  data() {
    return {
      // 定义图片资源
      images: [
        require('../assets/image1.jpg'),
        require('../assets/image3.jpg'),
        require('../assets/image4.jpg'),
        require('../assets/image8.jpg'),
        require('../assets/image2.jpg'),
        require('../assets/image5.jpg'),
        require('../assets/image7.jpg'),
        require('../assets/image6.jpg'),
      ]
    };
  }
}
</script>

<style scoped>

</style>
